import Vue from "vue"
import Vuex from "vuex"

import orders from "./modules/orders"

import products from "./modules/products"
import product_variants from "./modules/product-variants"
import product_collections from "./modules/product_collections"

import packagings from "./modules/packagings"
import customers from "./modules/customers"
import coupons from "./modules/coupons"
import media from "./modules/media"
import menus from "./modules/menus"
import backlinks from "./modules/backlinks"
import styles from "./modules/styles"

import pages from "./modules/pages"
import popups from "./modules/popups"
import components from "./modules/components"
import translations from "./modules/translations"

import general from "./modules/general"
import sites from "./modules/sites"
import signup from "./modules/signup"

import validations from "./modules/validations"

import forms from "./modules/forms"
import email_templates from "./modules/email-templates"

import zones from "./modules/zones"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    orders,
    customers,
    popups,
    pages,
    components,
    general,
    signup,
    products,
    product_variants,
    product_collections,
    coupons,
    media,
    menus,
    backlinks,
    styles,
    packagings,
    sites,
    forms,
    email_templates,
    translations,
    validations,
    zones
  }
})
